import axios from 'axios';
export const httpNoAuth = axios.create({
  baseURL: '/',
  withCredentials: false,
});
